// extracted by css-extract-rspack-plugin
export default {"AppTitleContainer":"AppTitle-module__AppTitleContainer__WfeY4","Heading":"AppTitle-module__Heading__oiISy"};